import script from "./MainTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainTable.vue?vue&type=script&setup=true&lang=ts"

import "./MainTable.vue?vue&type=style&index=0&id=3012442b&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3012442b"]])

export default __exports__